export default "__VITE_PUBLIC_ASSET__f687a51d__"